import UserSearch from './UserSearch'
import UserTable from './UserTable'

export const Manage = () => {
  return (
    <>
      <UserSearch />
      <UserTable />
    </>
  )
}
